export default __webpack_public_path__ + "static/media/uploadinvoice.298c0c0a.svg";